'use strict';

angular.module('schoolLinqApp').factory('dialogSearchHelper', [
	'$uibModal',
	'$location',
	'unitListItemService',
	'utilsService',
	function ($uibModal, $location, unitListItemService, utilsService) {
		function searchAccounts(modalConfig, selectAccountFunction) {
			$uibModal.open({
				template: require('@ajs/templates/dialog-search-helper-accounts-modal.html'),
				backdrop: 'static',
				keyboard: false,
				size: 'topMoveUp',
				controller: [
					'$scope',
					'$q',
					'$filter',
					'$uibModalInstance',
					'accountService',
					'accountStructureService',
					'authService',
					'USER_CLAIMS',
					'BUSY_MESSAGE',
					function ($scope, $q, $filter, modalInstance, accountService, accountStructureService, authService, USER_CLAIMS, BUSY_MESSAGE) {
						$scope.acctConfig = {
							limit: 10,
							startIndex: 0,
							pageSize: 10,
							search: {
								text: '',
								accountNumber: '',
								searchBy: 'Account',
							},
							unifiedAccountMask: '',
							accountTypeIds: null, // []
							bankId: null,
							useSearchAccount: true, // use accountService.searchAccount(accountTypeIds, description, accountNumber, limit, filter, bankId)
							useSearchFundAccount: false, // use accountService.searchFundAccount(... , excludePayroll = true)
							useSearchPayrollAccount: false, // use accountService.searchPayrollAccount(... , onlyPayroll = true)
							moduleName: null,
							allowAddNew: false,
						};

						$scope.dialogAccounts = [];
						$scope.filteredAccountList = [];

						if (!_.isNull(modalConfig) && !_.isUndefined(modalConfig)) {
							$scope.acctConfig.limit = !_.isUndefined(modalConfig.limit) ? modalConfig.limit : $scope.acctConfig.limit;
							$scope.acctConfig.startIndex = !_.isUndefined(modalConfig.startIndex)
								? modalConfig.startIndex
								: $scope.acctConfig.startIndex;
							$scope.acctConfig.pageSize = !_.isUndefined(modalConfig.pageSize) ? modalConfig.pageSize : $scope.acctConfig.pageSize;
							$scope.acctConfig.accountTypeIds = !_.isUndefined(modalConfig.accountTypeIds)
								? modalConfig.accountTypeIds
								: $scope.acctConfig.accountTypeIds;
							$scope.acctConfig.bankId = !_.isUndefined(modalConfig.bankId) ? modalConfig.bankId : $scope.acctConfig.bankId;
							$scope.acctConfig.useSearchAccount = !_.isUndefined(modalConfig.useSearchAccount)
								? modalConfig.useSearchAccount
								: $scope.acctConfig.useSearchAccount;
							$scope.acctConfig.useSearchFundAccount = !_.isUndefined(modalConfig.useSearchFundAccount)
								? modalConfig.useSearchFundAccount
								: $scope.acctConfig.useSearchFundAccount;
							$scope.acctConfig.useSearchPayrollAccount = !_.isUndefined(modalConfig.useSearchPayrollAccount)
								? modalConfig.useSearchPayrollAccount
								: $scope.acctConfig.useSearchPayrollAccount;
							$scope.acctConfig.moduleName = !_.isUndefined(modalConfig.moduleName)
								? modalConfig.moduleName
								: $scope.acctConfig.moduleName;
							$scope.acctConfig.allowAddNew = !_.isUndefined(modalConfig.allowAddNew)
								? modalConfig.allowAddNew
								: $scope.acctConfig.allowAddNew;

							if ($scope.acctConfig.allowAddNew === true) {
								$scope.acctConfig.allowAddNew = !authService.isReadOnly(USER_CLAIMS.lsb, 'Accounts', 'accounts');
							}
						}

						$scope.busyMessage = BUSY_MESSAGE.Loading;
						$scope.busyPromise = $q.all([loadAccounts(), loadAccountStructures()]);

						function loadAccounts() {
							return searchAccountsbyAccountNumber('', 0).then(finishLoadingAccounts);

							function finishLoadingAccounts(response) {
								$scope.dialogAccounts = response;
								return angular.noop;
							}
						}

						function searchAccountsbyAccountNumber(value, overrideLimit) {
							const limit = !_.isNull(overrideLimit) && !_.isUndefined(overrideLimit) ? overrideLimit : $scope.acctConfig.limit;
							const accountTypeIds = $scope.acctConfig.accountTypeIds;
							const bankId = $scope.acctConfig.bankId;

							if ($scope.acctConfig.useSearchFundAccount === true) {
								return accountService.searchFundAccount(accountTypeIds, '', value, limit, true, bankId).then(finishSearchAccounts);
							}

							if ($scope.acctConfig.useSearchPayrollAccount === true) {
								return accountService.searchPayrollAccount(accountTypeIds, '', value, limit, true, bankId).then(finishSearchAccounts);
							}

							return accountService.searchAccount(accountTypeIds, '', value, limit, true, bankId).then(finishSearchAccounts);

							function finishSearchAccounts(response) {
								return response.data.accounts;
							}
						}

						function loadAccountStructures() {
							return accountStructureService.getStructure().then(_.partial(finishLoadingAccountStructures));

							function finishLoadingAccountStructures(response) {
								$scope.acctConfig.unifiedAccountMask = response.data.accountStructure.UnifiedAccountMask;
								$scope.acctConfig.search.accountNumber = $scope.acctConfig.unifiedAccountMask.replace(/\./g, '').replace(/0/g, '?');
								return angular.noop;
							}
						}

						angular.extend($scope, {
							cancel: function () {
								modalInstance.close();
							},
							selectAccount: function (account) {
								if (!_.isNull(selectAccountFunction) && !_.isUndefined(selectAccountFunction)) {
									selectAccountFunction(account);
								}

								modalInstance.close();
							},
							openNewAccountModal: function () {
								if ($scope.acctConfig.allowAddNew !== true) {
									return;
								}

								$uibModal
									.open({
										template: require('@ajs/templates/dialog-search-helper-accounts-add-modal.html'),
										backdrop: 'static',
										keyboard: false,
										scope: $scope,
										controller: [
											'$scope',
											'$q',
											'$uibModalInstance',
											'dialogHelper',
											'accountService',
											'accountStructureService',
											function ($scope, $q, addNewModalInstance, dialogHelper, accountService, accountStructureService) {
												$scope.newAccount = {
													AccountTypeId: null,
													AccountNumber: null,
													Description: null,
													EffectiveDT: moment().toDate(),
													EndDT: new Date(2099, 5, 30),
													accountTypes: [],
													accountMask: null,
													selectedAccountEffectiveDateOpen: false,
													selectedAccountEndDateOpen: false,
													errors: null,
												};

												$scope.$watch(
													'newAccount',
													function (newAccount) {
														var acctType = _.find($scope.newAccount.accountTypes, function (value) {
															return value.Id === newAccount.AccountTypeId;
														});

														if (!_.isUndefined(acctType)) {
															$scope.newAccount.accountMask = acctType.Mask;
														}
													},
													true
												);

												$scope.busyMessage = BUSY_MESSAGE.Loading;
												$scope.busyPromise = loadAccountTypes().then(function () {
													$scope.newAccount.AccountTypeId = $scope.newAccount.accountTypes[0].Id;
													$scope.newAccount.accountMask = $scope.newAccount.accountTypes[0].Mask;
												});

												function loadAccountTypes() {
													return accountStructureService.getAccountTypes().then(finishLoadingAccountTypes);

													function finishLoadingAccountTypes(response) {
														$scope.newAccount.accountTypes = response.data.accountTypes;
														return angular.noop;
													}
												}

												angular.extend($scope, {
													cancel: function () {
														addNewModalInstance.close();
													},
													getElementMap: function () {
														var type = _.find($scope.newAccount.accountTypes, function (type) {
															return type.Id === $scope.newAccount.AccountTypeId;
														});
														return type ? type.ElementMap : '';
													},
													checkAccountNumber: function () {
														return $q
															.all([searchAccountsbyAccountNumber($scope.newAccount.AccountNumber)])
															.then(function (responses) {
																if (responses[0].length > 0) {
																	$scope.newAccount.errors = 'Account Number is already used.';
																	return false;
																}
																return true;
															});
													},
													verifyAccount: function () {
														return accountService.verifyAccount($scope.newAccount.AccountNumber);
													},
													save: function () {
														if (!$scope.accountForm.$valid) return false;
														$scope.newAccount.errors = null;
														$scope.checkAccountNumber().then(function (isValid) {
															if (!isValid) return false;

															// check if account # passes DPI validation
															$scope.verifyAccount().then(function (response) {
																if (response.data.isValid) {
																	$scope.saveContinue();
																	return true;
																} else {
																	let title = 'Confirm Invalid Account Number';
																	let messages = [];
																	messages.push(
																		'Account Number ' + $scope.newAccount.AccountNumber + ' is invalid to DPI.'
																	);
																	messages.push(null); // create a line break
																	messages.push('Do you want to save anyway?');
																	dialogHelper.yesnoMessageBox(
																		title,
																		null,
																		messages,
																		'Question',
																		$scope.saveContinue,
																		null
																	);
																}
															});
														});
													},
													saveContinue: function () {
														$scope.busyMessage = BUSY_MESSAGE.Saving;
														$scope.busyPromise = accountService.addAccount($scope.newAccount).then(function (response) {
															if (response.data.isValid) {
																$scope.newAccount.Id = response.data.accountId;
																addNewModalInstance.close($scope.newAccount);
															} else {
																$scope.newAccount.errors = response.data.errors;
															}
														});
													},
												});
											},
										],
									})
									.result.then(function (account) {
										if (account) {
											$scope.selectAccount(account);
										}
									});
							},
						});
					},
				],
			});
		}

		function searchVendors(modalConfig, selectVendorFunction) {
			$uibModal.open({
				template: require('@ajs/templates/dialog-search-helper-vendors-modal.html'),
				backdrop: 'static',
				keyboard: false,
				size: 'topMoveUp',
				controller: [
					'$scope',
					'$filter',
					'$uibModalInstance',
					'vendorService',
					'VENDOR_STATUS',
					'BUSY_MESSAGE',
					function ($scope, $filter, modalInstance, vendorService, VENDOR_STATUS, BUSY_MESSAGE) {
						$scope.vendorSearch = {
							statuses: [
								{ Id: 0, Description: 'All Vendors' },
								{ Id: 1, Description: 'Active Vendors' },
								{ Id: 2, Description: 'Inactive Vendors' },
							],
							statusesEnabled: false,
							vendors: [],
							numberOfVendors: 0,
							maxNumberOfVendors: 0,
							pageControl: {},
							currentSelectedStatusId: 1,
							currentSearchText: '',
							vendorPaging: {
								searchText: '',
								statusId: VENDOR_STATUS.Active,
								pageSize: 12,
								startIndex: 0,
								orderBy: 'ShortName',
								orderByDescending: false,
							},
						};

						if (!_.isNull(modalConfig) && !_.isUndefined(modalConfig)) {
							//################################
							//#### modalConfig parameters ####
							//################################
							//modalConfig = {
							// statusId: 0,1,2
							// statusEnabled: false,
							// pageSize: 15,
							// startIndex: 0,
							//}

							$scope.vendorSearch.vendorPaging.statusId = !_.isUndefined(modalConfig.statusId)
								? modalConfig.statusId
								: $scope.vendorSearch.vendorPaging.statusId;
							$scope.vendorSearch.statusesEnabled = !_.isUndefined(modalConfig.statusesEnabled)
								? modalConfig.statusesEnabled
								: $scope.vendorSearch.statusesEnabled;
							$scope.vendorSearch.vendorPaging.pageSize = !_.isUndefined(modalConfig.pageSize)
								? modalConfig.pageSize
								: $scope.vendorSearch.vendorPaging.pageSize;
							$scope.vendorSearch.vendorPaging.startIndex = !_.isUndefined(modalConfig.startIndex)
								? modalConfig.startIndex
								: $scope.vendorSearch.vendorPaging.startIndex;
						}

						$scope.busyMessage = BUSY_MESSAGE.Loading;
						$scope.busyPromise = loadVendors();

						function loadVendors() {
							return vendorService.getVendorsByPage($scope.vendorSearch.vendorPaging).then(finishLoadingVendors);

							function finishLoadingVendors(response) {
								$scope.vendorSearch.numberOfVendors = response.data.totalNumberOfVendors;
								if ($scope.vendorSearch.numberOfVendors > $scope.vendorSearch.maxNumberOfVendors) {
									$scope.vendorSearch.maxNumberOfVendors = $scope.vendorSearch.numberOfVendors;
								}
								$scope.vendorSearch.vendors = response.data.vendors;

								return angular.noop;
							}
						}

						angular.extend($scope, {
							changePage: function (isStatusChange) {
								if (isStatusChange) {
									$scope.vendorSearch.numberOfVendors = 0;
									$scope.vendorSearch.maxNumberOfVendors = 0;
								}

								$scope.vendorSearch.currentSelectedStatusId = $scope.vendorSearch.vendorPaging.statusId;
								//If the search text changes, it should reset to the first page of data
								$scope.vendorSearch.vendorPaging.startIndex =
									$scope.vendorSearch.currentSearchText === $scope.vendorSearch.vendorPaging.searchText
										? $scope.vendorSearch.pageControl.startIndex
										: 0;
								$scope.vendorSearch.currentSearchText = $scope.vendorSearch.vendorPaging.searchText;
								$scope.busyMessage = BUSY_MESSAGE.Loading;
								$scope.busyPromise = loadVendors();
							},
							sortby: function (propertyName) {
								$scope.vendorSearch.vendorPaging.orderByDescending =
									$scope.vendorSearch.vendorPaging.orderBy === propertyName
										? !$scope.vendorSearch.vendorPaging.orderByDescending
										: false;
								$scope.vendorSearch.vendorPaging.orderBy = propertyName;
								$scope.changePage();
							},

							cancel: function () {
								modalInstance.close();
							},
							selectVendor: function (vendor) {
								if (!_.isNull(selectVendorFunction) && !_.isUndefined(selectVendorFunction)) {
									selectVendorFunction(vendor);
								}

								modalInstance.close();
							},
						});
					},
				],
			});
		}

		function searchEmployees(modalConfig, selectEmployeeFunction) {
			$uibModal.open({
				template: require('@ajs/templates/dialog-search-helper-employees-modal.html'),
				backdrop: 'static',
				keyboard: false,
				size: 'topMoveUp',
				controller: [
					'$scope',
					'$filter',
					'$uibModalInstance',
					'employeeService',
					'BUSY_MESSAGE',
					function ($scope, $filter, modalInstance, employeeService, BUSY_MESSAGE) {
						$scope.employeeFilter = {
							statusId: 1,
							name: null,
							number: null,
							propertyName: 'FormattedFormalName',
							reverse: false,
							pageSize: 12,
							startIndex: 0,
						};

						if (!_.isNull(modalConfig) && !_.isUndefined(modalConfig)) {
							$scope.employeeFilter.statusId = !_.isUndefined(modalConfig.statusId)
								? modalConfig.statusId
								: $scope.employeeFilter.statusId;
							$scope.employeeFilter.pageSize = !_.isUndefined(modalConfig.pageSize)
								? modalConfig.pageSize
								: $scope.employeeFilter.pageSize;
							$scope.employeeFilter.startIndex = !_.isUndefined(modalConfig.startIndex)
								? modalConfig.startIndex
								: $scope.employeeFilter.startIndex;
						}

						$scope.filteredEmployeeList = [];
						$scope.busyMessage = BUSY_MESSAGE.Loading;
						$scope.busyPromise = loadEmployees();

						function loadEmployees() {
							return employeeService.search($scope.employeeFilter).then(finishLoadingEmployees);

							function finishLoadingEmployees(response) {
								$scope.dialogEmployees = response.data.employees;
							}
						}

						angular.extend($scope, {
							cancel: function () {
								modalInstance.close();
							},
							selectEmployee: function (employee) {
								if (!_.isNull(selectEmployeeFunction) && !_.isUndefined(selectEmployeeFunction)) {
									selectEmployeeFunction(employee);
								}

								modalInstance.close();
							},
						});
					},
				],
			});
		}

		function searchUnitListItems(modalConfig) {
			//#########################################
			//#### modalConfig parameters ####
			//#########################################
			//modalConfig = {
			// fieldName:                           (required) Table UnitListItems.FieldName
			// showDialog: null,                    if true is passed in, a dialog modal will open for the user to select an item.
			// selectUnitListItemFunction: null,    (required if showDialog === true) This is a passed in function used to load the local model with the selected item.
			// unitListItemTitle: null,             (required if showDialog === true) This is the dialog Title.
			// keyValueTitle: null,                 (required if showDialog === true) This is the column title for KeyValue.
			// displayValueTitle: null,             (required if showDialog === true) This is the column title for DisplayValue.
			// propertyName: 'keyValueSort',        (optional)
			// reverse: false,                      (optional)
			// pageSize: 12,                        (optional)
			// startIndex: 0                        (optional)
			//}

			if (_.isNull(modalConfig) || _.isUndefined(modalConfig)) {
				return;
			} else {
				if (_.isNull(modalConfig.fieldName) || _.isUndefined(modalConfig.fieldName)) {
					return;
				}
			}

			function getList() {
				return unitListItemService.getFieldList(modalConfig.fieldName).then(finishedLoadingItems);
				function finishedLoadingItems(response) {
					return response.data;
				}
			}

			function openModal() {
				$uibModal.open({
					template: require('@ajs/templates/dialog-search-helper-unitlistitems-modal.html'),
					backdrop: 'static',
					keyboard: false,
					size: 'topMoveUp',
					controller: [
						'$scope',
						'$filter',
						'$uibModalInstance',
						'utilsService',
						'BUSY_MESSAGE',
						function ($scope, $filter, modalInstance, utilsService, BUSY_MESSAGE) {
							$scope.config = {
								unitListItemTitle: 'Select an Item',
								searchText: '',
								keyValueTitle: 'Id',
								displayValueTitle: 'Description',
								propertyName: 'keyValueSort',
								selectUnitListItemFunction: null,
								reverse: false,
								pageSize: 12,
								startIndex: 0,
							};

							if (!_.isNull(modalConfig) && !_.isUndefined(modalConfig)) {
								$scope.config.fieldName = !_.isUndefined(modalConfig.fieldName) ? modalConfig.fieldName : $scope.config.fieldName;
								$scope.config.unitListItemTitle = !_.isUndefined(modalConfig.unitListItemTitle)
									? modalConfig.unitListItemTitle
									: $scope.config.unitListItemTitle;
								$scope.config.keyValueTitle = !_.isUndefined(modalConfig.keyValueTitle)
									? modalConfig.keyValueTitle
									: $scope.config.keyValueTitle;
								$scope.config.displayValueTitle = !_.isUndefined(modalConfig.displayValueTitle)
									? modalConfig.displayValueTitle
									: $scope.config.displayValueTitle;
								$scope.config.propertyName = !_.isUndefined(modalConfig.propertyName)
									? modalConfig.propertyName
									: $scope.config.propertyName;
								$scope.config.selectUnitListItemFunction = !_.isUndefined(modalConfig.selectUnitListItemFunction)
									? modalConfig.selectUnitListItemFunction
									: $scope.config.selectUnitListItemFunction;
								$scope.config.pageSize = !_.isUndefined(modalConfig.pageSize) ? modalConfig.pageSize : $scope.config.pageSize;
								$scope.config.startIndex = !_.isUndefined(modalConfig.startIndex) ? modalConfig.startIndex : $scope.config.startIndex;
							}

							$scope.unitListItems = [];
							$scope.busyMessage = BUSY_MESSAGE.Loading;
							$scope.busyPromise = loadUnitListItems();

							function loadUnitListItems() {
								return unitListItemService.getFieldList($scope.config.fieldName).then(finishedLoadingItems);
								function finishedLoadingItems(response) {
									$scope.unitListItems = response.data;
								}
							}

							angular.extend($scope, {
								cancel: function () {
									modalInstance.close();
								},
								sortBy: function (config, propertyName) {
									config.reverse = config.propertyName === propertyName ? !config.reverse : false;
									config.propertyName = propertyName;
								},
								selectUnitListItem: function (item) {
									if (
										!_.isNull($scope.config.selectUnitListItemFunction) &&
										!_.isUndefined($scope.config.selectUnitListItemFunction)
									) {
										$scope.config.selectUnitListItemFunction(item);
									}
									modalInstance.close();
								},
							});
						},
					],
				});
			}

			if (modalConfig.showDialog === true) {
				return openModal();
			}

			return getList();
		}

		return {
			searchAccounts: searchAccounts,
			searchVendors: searchVendors,
			searchEmployees: searchEmployees,
			searchUnitListItems: searchUnitListItems,
		};
	},
]);
